import React, { useRef, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import Sidebar from "../../../../components/AdminComponents/SideNav";
import CaSideNav from "../../../../components/AdminComponents/CaSideNav";
import {
  //   capitalizeWords,
  //   formatDateWithSuffix,
  capitalizeWords,
  remainingViewportHeight,
} from "../../../../components/icons/ApplicationColor";
// import CommonTopDetails from "../../../../components/AdminComponents/CommonTopDetails";
import { CustomerTopLevel } from "../../../../components/AdminComponents/MenuItems";
import {
  Card,
  Typography,
  Divider,
  Menu,
  Tooltip,
  Form,
  Row,
  Col,
  Select,
  Input,
  Button,
  // Tag,
  //   DatePicker,
  message,
  Switch,
} from "antd";
import {
  FileTextOutlined,
  ReadOutlined,
  TeamOutlined,
  BranchesOutlined,
  SaveOutlined,
  BackwardOutlined,
  RetweetOutlined,
} from "@ant-design/icons";
// import "../courseStyles.css";

import axiosInstance from "../../../../api/Axios";
import {
  FormInput,
  CUSTOMER_NAME_FIELD,
  CUSTOMER_ID_FIELD,
} from "../../CAAdminCoursePages/courseForm";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { useSelector } from "react-redux";
import { PatternFormat } from "react-number-format";
import CustomerRightAdd from "./CustomerRightAdd";
// import dayjs from "dayjs";
// const dateFormat = "MMM DD YYYY";
const { Title, Paragraph } = Typography;
const { Option } = Select;

const CustomerAdd = () => {
  const location = useLocation();
  const userInfo = useSelector((state) => state.user);
  const classification = useSelector(
    (state) => state.orgdeatil.customerClassification
  );
  const brokerName = useSelector((state) => state.orgdeatil.brokerName);
  const [relationshipOptions, setRelationshipOptions] = useState([]);
  const isCAAdmin = location.pathname.includes("ca-admin");
  const WrapperComponent = isCAAdmin ? CaSideNav : Sidebar;
  const wrapperProps = isCAAdmin ? CustomerTopLevel : CustomerTopLevel;
  const [activeView, setActiveView] = useState("summary");
  const [formValues, setFormValues] = useState({});
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const history = useNavigate();
  const tooltip_title = "This menu will be available after saving the customer";
  const menuItems = [
    {
      key: "summary",
      label: (
        <div className="menu-vertical-item">
          <FileTextOutlined style={{ fontSize: "22px" }} />
          <div>Profile</div>
        </div>
      ),
      disabled: false,
    },
    isCAAdmin && {
      key: "department",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <BranchesOutlined style={{ fontSize: "22px" }} />
              <div>Access</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      key: "courses",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <TeamOutlined style={{ fontSize: "22px" }} />

              <div>Users</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
    isCAAdmin && {
      key: "users",
      disabled: true,
      label: (
        <div className="menu-vertical-item disabled">
          <Tooltip title={tooltip_title}>
            <span
              style={{
                pointerEvents: "auto",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <ReadOutlined style={{ fontSize: "22px" }} />
              <div>Events</div>
            </span>
          </Tooltip>
        </div>
      ),
    },
  ];
  const [form] = Form.useForm();
  const [uploadedFiles, setUploadedFiles] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const formRef = useRef();

  const fetchRelationships = async () => {
    try {
      const orgId = userInfo?.data?.organization?.id;
      if (orgId) {
        const res = await axiosInstance.get(
          `accountrelationshiplist/?page=1&page_size=15&organization=${orgId}`
        );
        console.log("Account Relationships:", res.data);
        setRelationshipOptions(res.data?.results || []);
      }
    } catch (error) {
      console.error("Error fetching relationships:", error);
    }
  };

  React.useEffect(() => {
    fetchRelationships();
  }, [userInfo?.data?.organization?.id]);


  const handleInsurerNameChange = (value) => {
    form.setFieldsValue({ insurer_id: value });
  };

  const handleInsurerIdChange = (value) => {
    form.setFieldsValue({ insurer_name: value });
  };


  const CreateSuccessfull = (id, data) => {
    messageApi.open({
      type: "success",
      content: `${classification ? capitalizeWords(classification) : "Customer"} creation success.`,
      duration: 5,
    });
    console.log(id, data);
    setTimeout(() => {
      setTimeout(() => {
        history(
          isCAAdmin
            ? `/ca-admin/customers/edit/${id}`
            : `/customers/edit/${id}`
        );
      }, 2000);
    }, 2000);
  };

  const CreateFailed = () => {
    messageApi.open({
      type: "error",
      content: `${classification ? capitalizeWords(classification) : "Customer"} Creation failure`,
      duration: 5,
    });
  };

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
      const [cookieName, cookieValue] = cookies[i].split("=");
      if (cookieName === name) {
        return cookieValue;
      }
    }
    return null;
  }
  const csrfToken = getCookie("csrftoken");
  const handleSubmit = async (values) => {
    setLoading(true);
    const normalizedValues = Object.fromEntries(
      Object.entries(values).filter(
        ([key, value]) => value !== null && value !== undefined
      )
    );
    const { deactivate_on, due_date, description, insurer_name, insurer_id, ...rest } = normalizedValues;

    const finalValues = {
      ...rest,
      logo_url: uploadedFiles,
      parent_key: userInfo?.data?.organization?.id,
      account_relationship_id: insurer_name,
    };

    console.log("Form submitted with values:", finalValues);
    try {
      const res = await axiosInstance.post(`customer/customers/`, finalValues, {
        headers: {
          "X-CSRFToken": csrfToken,
        },
      });
      console.log(res, "customer-res");
      CreateSuccessfull(res?.data?.id, res);
    } catch (err) {
      CreateFailed();
    }
  };
  return (
    <WrapperComponent props={wrapperProps}>
      {contextHolder}
      <div
        style={{
          background: "#f4f4f4",
          width: "100%",
          height: remainingViewportHeight(10),
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          padding: "24px",
          overflowY: "auto",
          gap: "24px",
          marginTop: "50px",
        }}
      >
        <div style={{ flexBasis: "10%", height: "100%" }}>
          <Card
            bordered
            hoverable
            style={{
              height: "100%",
              borderRadius: "12px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
              display: "flex",
              flexDirection: "column",
              padding: "5px",
              background: "#F9FBFC",
            }}
            className="no-padding-no-margin"
          >
            <Title
              // level={}
              style={{
                fontSize: "15.5px",
                textAlign: "center",
                width: "100%",
                // display: "block",
                fontWeight: "600",
                letterSpacing: 0.5,
                color: "#333333",
                marginTop: "28.5px",
              }}
            >
              Add {classification ? capitalizeWords(classification) : "Customer"}
            </Title>

            <Divider />
            <div style={{ paddingInline: "5px" }}>
              <Menu
                className="modern-sidebar-menu"
                mode="inline"
                selectedKeys={[activeView]}
                onClick={({ key }) => setActiveView(key)}
                style={{
                  flex: 1,
                  overflowY: "auto",
                  borderRight: "none",
                  width: "100%",
                  background: "transparent",
                }}
                items={menuItems}
              />
            </div>
          </Card>
        </div>
        <div style={{ flexBasis: "70%", display: "flex" }}>
          <Card
            style={{
              width: "100%",

              marginBottom: "10px",
            }}
            hoverable
          >
            <Title level={4}>
              {classification ? capitalizeWords(classification) : "Customer"}{" "}
              Creation
            </Title>
            <Paragraph type="secondary">
              Create and configure your new{" "}
              {classification ? capitalizeWords(classification) : "Customer"} with
              the details below
            </Paragraph>
            <Form
              layout="vertical"
              onFinish={handleSubmit}
              name="complex-form"
              form={form}
              ref={formRef}
              onValuesChange={(_, allValues) => setFormValues(allValues)}
            >
              <Row gutter={16}>
                <FormInput
                  field={{
                    ...CUSTOMER_NAME_FIELD,
                    span: 12,
                    label: classification
                      ? `${capitalizeWords(classification)} Name`
                      : CUSTOMER_NAME_FIELD.label,
                    placeholder: classification
                      ? `Enter ${capitalizeWords(classification)} name`
                      : CUSTOMER_NAME_FIELD.placeholder,
                    rules: CUSTOMER_NAME_FIELD.rules.map((rule) => ({
                      ...rule,
                      message: classification
                        ? rule.message?.replace(
                          "Customer",
                          capitalizeWords(classification)
                        )
                        : rule.message,
                    })),
                  }}
                />
                <FormInput
                  field={{
                    ...CUSTOMER_ID_FIELD,
                    span: 12,
                    label: classification
                      ? `${capitalizeWords(classification)} ID`
                      : CUSTOMER_ID_FIELD.label,
                    placeholder: classification
                      ? `Enter ${capitalizeWords(classification)} ID`
                      : CUSTOMER_ID_FIELD.placeholder,
                    rules: CUSTOMER_ID_FIELD.rules.map((rule) => ({
                      ...rule,
                      message: classification
                        ? rule.message?.replace(
                          "Customer",
                          capitalizeWords(classification)
                        )
                        : rule.message,
                    })),
                  }}
                />
              </Row>

              {relationshipOptions.length > 0 && (
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item label={`${brokerName || "Insurer"} Name`} name="insurer_name">
                      <Select
                        placeholder={`Select ${brokerName || "Insurer"} Name`}
                        onChange={handleInsurerNameChange}
                      >
                        {relationshipOptions.map((opt) => (
                          <Option key={opt.id} value={opt.id}>
                            {opt.insurer_name || opt.account_name}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label={`${brokerName || "Insurer"} ID`} name="insurer_id">
                      <Select
                        placeholder={`Select ${brokerName || "Insurer"} ID`}
                        onChange={handleInsurerIdChange}
                      >
                        {relationshipOptions.map((opt) => (
                          <Option key={opt.id} value={opt.id}>
                            {opt.insurer_id || opt.account_id}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <Row gutter={20}>
                <Col span={8}>
                  <Form.Item label="Country">
                    <Input.Group compact>
                      <Form.Item name="country" noStyle>
                        <CountryDropdown
                          // countryValueType="short"
                          //   disabled={!updateAuth}
                          value={selectedCountry}
                          onChange={(val) => setSelectedCountry(val)}
                          //   placeholder="Select County"
                          className="my-form-input-antd-test"
                          style={{
                            height: "3rem",
                            border: "0.1rem solid gray",
                          }}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="State">
                    <Input.Group compact>
                      <Form.Item name="state" noStyle>
                        <RegionDropdown
                          // countryValueType="short"
                          //   disabled={!updateAuth}
                          country={selectedCountry}
                          value={selectedState}
                          onChange={(val) => setSelectedState(val)}
                          className="my-form-input-antd-test"
                          style={{
                            height: "3rem",
                            border: "0.1rem solid gray",
                          }}
                        />
                      </Form.Item>
                    </Input.Group>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="City" name="city">
                    <Input placeholder="Enter City" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col span={8}>
                  <Form.Item
                    name="zipcode"
                    label="ZIP/Postal Code"
                    rules={[
                      {
                        pattern:
                          selectedCountry === "United Kingdom"
                            ? /^[0-9a-zA-Z]*$/
                            : /^[0-9]*$/,
                        message:
                          selectedCountry === "United Kingdom"
                            ? "Please enter valid characters only"
                            : "Please enter numbers only",
                      },
                      {
                        min:
                          selectedCountry === "United States" ||
                            selectedCountry === "India" ||
                            selectedCountry === "United Kingdom" ||
                            selectedCountry === ""
                            ? 5
                            : undefined,
                        max:
                          selectedCountry === ""
                            ? 5
                            : selectedCountry === "United States"
                              ? 5
                              : selectedCountry === "India"
                                ? 6
                                : selectedCountry === "United Kingdom"
                                  ? 7
                                  : undefined,
                        message: "Invalid postal code",
                      },
                    ]}
                  >
                    <Input placeholder="zip code" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="EIN/Tax ID">
                    <Form.Item
                      name="ein"
                      noStyle
                      rules={[
                        {
                          pattern: /^\d{2}-\d{7}$/,
                          message: "EIN format req xx-xxxxxxx",
                        },
                      ]}
                    >
                      <PatternFormat
                        //  disabled={!updateAuth}
                        format="##-#######"
                        className="my-form-input-antd-test"
                        style={{
                          paddingTop: "0.57rem",
                          paddingBottom: "0.57rem",
                          paddingLeft: "0.7rem",
                          borderRadius: "0.5rem",
                          border: "0.1rem solid gray",
                        }}
                        placeholder={" xx-xxxxxxx"}
                      />
                    </Form.Item>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Industry" name="industry">
                    <Input
                      placeholder={`Enter ${classification ? capitalizeWords(classification) : "Customer"} Industry`}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={`${classification ? capitalizeWords(classification) : "Customer"} Type`}
                    name="org_type"
                  >
                    <Select placeholder="Select Type">
                      <Option value="non-profit">Non Profit</Option>
                      <Option value="profit">Profit</Option>
                      <Option value="Local Government">Local Government</Option>
                      <Option value="Individual">Individual</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label="Enrollment Type" name="enrollment_type">
                    <Select placeholder="Select Enrollment Type">
                      <Option value="Organization">Organization</Option>
                      <Option value="Individual Instructor">
                        Individual Instructor
                      </Option>
                      <Option value="Training Company">Training Company</Option>
                      <Option value="Consultant Company">
                        Consultant Company
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label="Portal Access"
                    name="access"
                    valuePropName="checked"
                  >
                    <Switch checkedChildren="Yes" unCheckedChildren="No" />
                  </Form.Item>
                </Col>
              </Row>
              {" "}
              {false && (
                <Row gutter={16}>
                  <Col span={24}>
                    <Form.Item
                      label={`${classification ? capitalizeWords(classification) : "Customer"} Description`}
                      name="description"
                    >
                      <Input.TextArea
                        rows={4}
                        placeholder="Enter description"
                      />
                    </Form.Item>
                  </Col>
                </Row>
              )}
              <div
                className="group-1-box"
                style={{
                  paddingTop: "0rem",
                  paddingLeft: "0px",
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <div>
                  <div style={{ display: "inline-block" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        style={{
                          background: "#D3D3D3",
                        }}
                        onClick={() => {
                          history(
                            isCAAdmin
                              ? "/ca-admin/trainery-learn/bundles/listing"
                              : "/trainery-learn/courses/listing"
                          );
                        }}
                      >
                        <BackwardOutlined />
                        Back
                      </Button>
                    </Form.Item>
                  </div>

                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false} shouldUpdate>
                      {() => (
                        <Button
                          type="primary"
                          htmlType="submit"
                          className="save-update-btn"
                          loading={loading}
                          disabled={
                            form.getFieldsError().some(({ errors }) => errors.length > 0)
                          }
                        >
                          Save & Continue
                          <SaveOutlined />
                        </Button>
                      )}
                    </Form.Item>
                  </div>
                  <div style={{ display: "inline-block", marginLeft: "16px" }}>
                    <Form.Item label=" " colon={false}>
                      <Button
                        type="text"
                        htmlType="button"
                        onClick={() => {}}
                        style={{
                          background: "#D3D3D3",
                        }}
                      >
                        Reset
                        <RetweetOutlined />
                      </Button>
                    </Form.Item>
                  </div>
                </div>
              </div>
            </Form>
          </Card>
        </div>
        <div style={{ flexBasis: "20%", height: "100%", marginRight: "15px" }}>
          <CustomerRightAdd
            formData={formValues}
            setUploadedFiles={setUploadedFiles}
          />
        </div>
      </div>
    </WrapperComponent>
  );
};

export default CustomerAdd;
